// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TokensAndPots/TokenPotModal.css
// module id = 3076
// module chunks = 0